import React, {Component} from 'react';
import { RTLTable,RTLCol,RTLButton } from '../RTLKit';
import {Tag ,Divider, Icon, Row, Tooltip, Pagination, Form, Popconfirm,Collapse,Rate, Typography } from 'antd';
import {Field, reduxForm} from "redux-form";
import Loading from '../loading/loading';
import moment from 'jalali-moment'
import TextField from "../formFields/TextField";
import SelectField from "../formFields/SelectField";
import SelectFieldForLoadCity from "../formFields/SelectFieldForLoadCity";
import SelectFieldForLoadState from "../formFields/SelectFieldForLoadState";
import { CSVLink  } from "react-csv";
import DatePickerField from "../formFields/DatePickerField";

const columns = [
    {
        title: 'ردیف',
        dataIndex: 'key',
        // width:'4%'
    },
    {
        title: 'کد سیستمی',
        dataIndex: 'system_code',
        sorter: (a, b) => a.system_code - b.system_code,
        // width:'9%'
    },
    {
        title: 'کاربر',
        dataIndex: 'name',
        // width:'9%'
    },
    {
        title: 'شماره تماس',
        dataIndex: 'mobile',
        // width:'9%'
    },
    {
        title: 'وضعیت',
        dataIndex: 'value',
        // width:'9%'
    },
    {
        title: 'یادداشت',
        dataIndex: 'note',
        // width:'9%'
    },
    {
        title: 'زمان تماس مجدد',
        dataIndex: 'call_time',
        // width:'9%'
    },
    {
        title: 'تاریخ ایجاد',
        dataIndex: 'created_at',
        // width:'9%'
    },
  ];
const header = [
    {
        label: 'ردیف',
        key: 'key',
    },
    {
        label: 'کد سیستمی',
        key: 'system_code',
    },
    {
        label: 'کاربر',
        key: 'name',
    },
    {
        label: 'شماره تماس',
        key: 'mobile',
    },
    {
        label: 'وضعیت',
        key: 'value',
    },
    {
        label: 'یادداشت',
        key: 'note',
    },
    {
        label: 'زمان تماس مجدد',
        key: 'call_time',
    },
    {
        label: 'تاریخ ایجاد',
        key: 'created_at',
    },
];

const expandedRowRender = record => <div>{record.extraInfo}</div>;

class TicketList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            formLayout: 'horizontal',
            role:'',
            searchBoxHidden:true, //hidden=true
            loading:false,
            pageSize:10,
            current: (this.props.list ? this.props.list.pageNumber : 1),
            visible: false,
            expandedRowRender,
            filter:[],
            search:false,
            customer_by:this.props.match.params.userId ? this.props.match.params.userId : '',
        }
        this.__onChangeCounter = this.__onChangeCounter.bind(this)
    }

    componentWillMount() {
        // this.props.getUserList({role:"TECHNICIAN",size:100});
    }

    componentDidMount() {
        let _ = require('lodash');
        this.props.getAreaList();
        this.props.getStateList({size:200});
        // this.props.getStateList({size:10});
        // this.props.getCityList({size:200});
        // this.props.getCityList({size:10});
        this.props.getCityList({size:200});
        // this.props.getListForExcel({size:10000});
        if(this.props.match.params.userId) {
            let userId = this.props.match.params.userId;
            if(_.includes(this.props.match.path,'customer')) {
                this.props.getList({customer_by: userId})
                this.setState(prevState  => ({
                    filter: {...prevState.filter,customer_by:userId}
                }))
            }else {
                this.setState(prevState  => ({
                    filter: {...prevState.filter,technician_by:userId}
                }))
                this.props.getList({technician_by: userId})
            }
            this.props.getUserInfo(userId)
        }else{
            this.props.getList()
            // this.interval = setInterval(() => this.props.getList(), 20000);
        }
    }

   /*--- pagination ---*/
    async handlePageChange(pageNumber) {
        clearInterval(this.interval);
        this.setState({current: pageNumber});
        await this.setState(prevState  => ({
            filter: {...prevState.filter,page:pageNumber}
        }))
        this.props.getList(this.state.filter);
    }

    /*-- search form ---*/
    onFormSubmit(value) {
        if(this.state.system_code)
            this.setState(prevState  => ({
                filter: {...prevState.filter,system_code:this.state.system_code}
            }))
        if(this.state.created_from)
            this.setState(prevState  => ({
                filter: {...prevState.filter,created_from:this.state.created_from}
            }))
        if(this.state.created_to)
            this.setState(prevState  => ({
                filter: {...prevState.filter,created_to:this.state.created_to}
            }))
        if(this.state.call_time_from)
            this.setState(prevState  => ({
                filter: {...prevState.filter,call_time_from:this.state.call_time_from}
            }))
        if(this.state.call_time_to)
            this.setState(prevState  => ({
                filter: {...prevState.filter,call_time_to:this.state.call_time_to}
            }))
        if(this.state.user)
            this.setState(prevState  => ({
                filter: {...prevState.filter,user:this.state.user}
            }))
        if(this.state.value)
            this.setState(prevState  => ({
                filter: {...prevState.filter,value:this.state.value}
            }))
        this.props.handleSubmit(value);
        clearInterval(this.interval);
    }

    __translateUserticketTitle(type){
        switch (type) {
            case 'WERE_CONTACTED':
                return 'تماس گرفته شد.';
            case 'THEY_CHANGE_THEMSELVES':
                return 'خودشان تعویض می کنند.'
            case 'THEY_DID_NOT_ANSWER':
                return 'پاسخ ندادند.';
            case 'IT_IS_OFF':
                return 'خاموش بود.';
            case 'BLOCK_LIST':
                return 'بلاک لیست.';
            case 'THEY_CALL_THEMSELVES':
                return 'خودشان تماس میگیرند.';
            case 'RELUCTANCE_TO_RECEIVE_SERVICE':
                return 'عدم تمایل به دریافت سرویس.';
            case 'FREE_VISIT':
                return 'بازدید رایگان.';
            case 'MISCELLANEOUE':
                return 'متفرقه';
            case 'CALL_BACK':
                return 'تماس مجدد';
        }
    }

    __fixListForShowInTable() {
        let list = this.props.list;
        let dataSource = [];
        let stateList = []
        let cityList = []
        let _ = require('lodash');
        

        if(this.props.stateList)
            stateList = this.props.stateList.lists

        if(this.props.cityList)
            cityList = this.props.cityList.lists

        if(list && list.lists) {

            for (let i = 0; i < list.lists.length; i++) {
                // let stateName;
                // let cityName;

                // /*---- stateName ----*/
                // stateList.map((state,index) => {
                //     if(state._id === list.lists[i].address.stateId)
                //         stateName = state.title
                // })
            
                // /*---- cityName ----*/
                // cityList.map((city,index) => {
                //     if(city._id === list.lists[i].address.cityId)
                //         cityName = city.title
                // })

                dataSource.push({
                    key: (this.state.pageSize*(list.page_number-1))+(i+1),
                    system_code: list.lists[i].system_code,
                    value : this.__translateUserticketTitle(list.lists[i].value),
                    title: list.lists[i].title,
                    note: list.lists[i].note,
                    user: list.lists[i].user,
                    created_at:moment(list.lists[i]?.created_at).format('jYYYY/jM/jD'),
                    call_time:moment(list.lists[i]?.call_time).format('jYYYY/jM/jD'),
                    name:list?.lists[i]?.user?.name+" "+list?.lists[i]?.user?.family,
                    mobile:list?.lists[i]?.user?.mobile,
                });
            }
        }

        return dataSource;
    }

    __toggleSearchBox(){
        this.setState({
            searchBoxHidden : !this.state.searchBoxHidden
        })
    }

    async __onChangeCounter(current, pageSize) {
        clearInterval(this.interval);
        this.setState({size:pageSize});
        this.setState({pageSize:pageSize})
        await this.setState(prevState  => ({
            filter: {...prevState.filter,page:current,size:pageSize}
        }))
        this.props.getList(this.state.filter);
    }

    __clearFilter() {
        this.props.reset();
        if(this.props.match.params.userId) {
            let userId = this.props.match.params.userId;
            this.props.getList({technician_by:userId})
        }else{
            this.props.getList();
        }
        this.setState({current:1})
    }

    __goBack(){
        this.props.history.goBack()
    }

    showExcel() {
        let list = this.props.list;
        let _ = require('lodash');
        let a=[]

        if(list && list.lists) {
            for (let i = 0; i < list.lists.length; i++) {
                a.push({
                    key: (this.state.pageSize*(list.page_number-1))+(i+1),
                    system_code: list.lists[i].system_code,
                    value : this.__translateUserticketTitle(list.lists[i].value),
                    title: list.lists[i].title,
                    note: list.lists[i].note,
                    user: list.lists[i].user,
                    created_at:moment(list.lists[i]?.created_at).format('jYYYY/jM/jD'),
                    call_time:moment(list.lists[i]?.call_time).format('jYYYY/jM/jD'),
                    name:list.lists[i]?.user?.name+" "+list.lists[i]?.user?.family,
                    mobile:list.lists[i]?.user?.mobile,
                });
            }
        }

        return a
    }

    __getAreaStateList() {
        let areaList = this.props.areaList;
        let dataSource = [];

        if (areaList) {

            for (let i = 0; i < areaList.length; i++) {

                dataSource.push(
                    {label: areaList[i].title, value: areaList[i]._id, key: i,cities:areaList[i].cities}
                );

            }

        }
        return dataSource;
    }

    __fixCitiesObject(list) {
        let dataSource = [];
        if (list) {
            for (let i = 0; i < list.length; i++) {
                dataSource.push(
                    {label: list[i].title, value: list[i]._id, key: i}
                );
            }
        }
        return dataSource;
    }

    render() {
        let _self = this;
        const {searchBoxHidden } = this.state;
        const { list } = this.props;
        let fromDateVal;
        // var data = this.__fixListForShowInExcel()

        /* ----- Get List of state -----*/
        var stateList = this.__getAreaStateList();
        var cityList = [];

        if(this.state.stateId)
        {
            for(let i  = 0;i< stateList.length ; i++)
            {
                if (stateList[i]['value'] == this.state.stateId)
                {
                    cityList = stateList[i]['cities'];
                    cityList = _self.__fixCitiesObject(cityList); //-- fix city object for Selecbox field
                }
            }
        }

        if(this.state.fromDate && this.state.fromDate._d)
            fromDateVal = this.state.fromDate._d

        var data = this.showExcel();

        return (
            <div>
                <Row type="flex">
                    <RTLCol xs={24} md={18}>
                        <Divider orientation="left">گزارش تیکت ها</Divider>
                    </RTLCol>
                    <RTLCol xs={24} md={6} >
                        <RTLButton type="primary" className="userListBtn" shape="round" icon="search" onClick={this.__toggleSearchBox.bind(this)} ></RTLButton>
                        {data.length>0?
                            <RTLButton type="primary" className="userListBtn" shape="round" >
                                <CSVLink
                                    data={data}
                                    headers={header}
                                    className='export-link'
                                    filename={"invoice-report.csv"}
                                    target="_blank"
                                >
                                    خروجی اکسل
                                </CSVLink>
                                
                            </RTLButton>
                        :null}
                    </RTLCol>
                </Row>
                <Row>
                    <Form name="search" onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                        <Row gutter={4} type="flex" justify="start" align="top" hidden={searchBoxHidden} >
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="system_code"
                                    component={TextField}
                                    type="text"
                                    placeholder="کد سیستمی"
                                    onBlur={(system_code) => {
                                        this.setState(prevState  => ({
                                            filter: {...prevState.filter,system_code:system_code.target.value}
                                        }))
                                    }}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="user"
                                    component={TextField}
                                    type="text"
                                    placeholder="شماره همراه"
                                    maxLength={11}
                                    onBlur={(user) => {
                                        this.setState(prevState  => ({
                                            filter: {...prevState.filter,user:user.target.value}
                                        }))
                                    }}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="state"
                                    component={SelectFieldForLoadState}
                                    placeholder="استان"
                                    list={stateList}
                                    onChangeVal={(stateId) => {
                                        _self.setState({stateId : stateId})
                                        this.setState(prevState  => ({
                                            filter: {...prevState.filter,stateId:stateId}
                                        }))
                                    }}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="city"
                                    component={SelectFieldForLoadCity}
                                    placeholder="شهر"
                                    list={cityList}
                                    onChange={(city) => {
                                        this.setState(prevState  => ({
                                            filter: {...prevState.filter,city:city}
                                        }))
                                    }}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="value"
                                    component={SelectField}
                                    placeholder="وضعیت  تیکت"
                                    list={[
                                        {label: 'تماس گرفته شد.', value: 'WERE_CONTACTED'},
                                        {label: 'خودشان تعویض می کنند.', value: 'THEY_CHANGE_THEMSELVES'},
                                        {label: 'پاسخ ندادند.', value: 'THEY_DID_NOT_ANSWER'},
                                        {label: 'خاموش بود.', value: 'IT_IS_OFF'},
                                        {label: 'بلاک لیست.', value: 'BLOCK_LIST'},
                                        {label: 'خودشان تماس میگیرند.', value: 'THEY_CALL_THEMSELVES'},
                                        {label: 'عدم تمایل به دریافت سرویس.', value: 'RELUCTANCE_TO_RECEIVE_SERVICE'},
                                        {label: 'بازدید رایگان.', value: 'FREE_VISIT'},
                                        {label: 'متفرقه', value: 'MISCELLANEOUE'},
                                        {label: 'تماس مجدد', value: 'CALL_BACK'},
                                    ]}
                                    onChange={(value) => {
                                        this.setState(prevState  => ({
                                            filter: {...prevState.filter,value:value}
                                        }))
                                    }}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="created_from"
                                    component={DatePickerField}
                                    placeholder="از تاریخ"
                                    timePicker={false}
                                    onChange={(created_from) => {
                                        _self.setState({created_from : created_from})
                                        this.setState(prevState  => ({
                                            filter: {...prevState.filter,created_from:created_from}
                                        }))
                                    }}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="created_to"
                                    component={DatePickerField}
                                    placeholder="تا تاریخ"
                                    timePicker={false}
                                    onChange={(created_to) => {
                                        _self.setState({created_to : created_to})
                                        this.setState(prevState  => ({
                                            filter: {...prevState.filter,created_to:created_to}
                                        }))
                                    }}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="call_time_from"
                                    component={DatePickerField}
                                    placeholder="تماس مجدد از تاریخ"
                                    timePicker={false}
                                    onChange={(call_time_from) => {
                                        _self.setState({call_time_from : call_time_from})
                                        this.setState(prevState  => ({
                                            filter: {...prevState.filter,call_time_from:call_time_from}
                                        }))
                                    }}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="call_time_to"
                                    component={DatePickerField}
                                    placeholder="تماس مجدد تا تاریخ"
                                    timePicker={false}
                                    onChange={(call_time_to) => {
                                        _self.setState({call_time_to : call_time_to})
                                        this.setState(prevState  => ({
                                            filter: {...prevState.filter,call_time_to:call_time_to}
                                        }))
                                    }}
                                />
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                <RTLButton className="left" type="default" shape="round" onClick={this.__clearFilter.bind(this)}>
                                    بروزرسانی
                                </RTLButton>
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                <RTLButton loading={this.props.common.isProgressing} className="left" type="primary" shape="round" htmlType="submit">
                                    جستجو
                                </RTLButton>
                            </RTLCol>
                        </Row>
                    </Form>
                </Row>
                <Row>
                    <RTLTable rowClassName={(record, index) => (index+1)%2 == 0 ? 'even' : 'odd' } {...this.state} className="orderList" pagination={false} columns={columns} dataSource={this.__fixListForShowInTable()} size="small" />
                    <Loading list={list} />
                </Row>
                <Row type="flex" justify="space-between">
                    <RTLCol md={14} className="right">
                        {this.state.filter.customer_mobile ? null :
                            <Pagination
                                name="pageNum"
                                current={this.state.current}
                                total={(list ? list.count : this.state.size)}
                                onChange={(pageNum) => this.handlePageChange(pageNum)}
                                pageSizeOptions={['10', '20','30','40','50','60','70','80','90','100']}
                                showSizeChanger
                                onShowSizeChange={this.__onChangeCounter}
                            />
                        }
                    </RTLCol>
                    <RTLButton onClick={this.__goBack.bind(this)} className="backBtn2" type="default" >
                        بازگشت
                    </RTLButton>
                </Row>
          </div>
        );
    }

}

export default TicketList = reduxForm({
    form: 'list',
})(TicketList)
